/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkInvoiceRead,
  ExportBulkInvoicesParams,
  GetBulkInvoicesParams,
  HTTPValidationError,
  MarkBulkInvoicePaidParams,
  PageBulkInvoiceManyRead,
  UpdateBulkInvoiceDueDateParams,
  UpdateBulkInvoicePaymentCollectorParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to get many bulk invoices.

Results are paginated and scoped to the current user's entities, matching either as
the ordering entity or as the payment collector.
 * @summary Get Bulk Invoices
 */
export const getBulkInvoices = (
  params?: GetBulkInvoicesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageBulkInvoiceManyRead>({
    url: `/api/bulk_invoice/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBulkInvoicesQueryKey = (params?: GetBulkInvoicesParams) => {
  return ["api", "bulk_invoice", ...(params ? [params] : [])] as const;
};

export const getGetBulkInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBulkInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkInvoices>>> = ({
    signal,
  }) => getBulkInvoices(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkInvoices>>
>;
export type GetBulkInvoicesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkInvoices<
  TData = Awaited<ReturnType<typeof getBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkInvoicesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoices>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoices>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoices<
  TData = Awaited<ReturnType<typeof getBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoices>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoices>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoices<
  TData = Awaited<ReturnType<typeof getBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Invoices
 */

export function useGetBulkInvoices<
  TData = Awaited<ReturnType<typeof getBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export bulk invoices to CSV with true streaming.
Uses the same filters and scoping as the base GET endpoint.
 * @summary Export Bulk Invoices
 */
export const exportBulkInvoices = (
  params?: ExportBulkInvoicesParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_invoice/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportBulkInvoicesQueryKey = (
  params?: ExportBulkInvoicesParams,
) => {
  return [
    "api",
    "bulk_invoice",
    "export",
    ...(params ? [params] : []),
  ] as const;
};

export const getExportBulkInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof exportBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportBulkInvoicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportBulkInvoices>>
  > = ({ signal }) => exportBulkInvoices(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportBulkInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportBulkInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportBulkInvoices>>
>;
export type ExportBulkInvoicesQueryError =
  ErrorType<void | HTTPValidationError>;

export function useExportBulkInvoices<
  TData = Awaited<ReturnType<typeof exportBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportBulkInvoicesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkInvoices>>,
          TError,
          Awaited<ReturnType<typeof exportBulkInvoices>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkInvoices<
  TData = Awaited<ReturnType<typeof exportBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkInvoices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkInvoices>>,
          TError,
          Awaited<ReturnType<typeof exportBulkInvoices>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkInvoices<
  TData = Awaited<ReturnType<typeof exportBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Bulk Invoices
 */

export function useExportBulkInvoices<
  TData = Awaited<ReturnType<typeof exportBulkInvoices>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkInvoices>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportBulkInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a bulk invoice by ID.
 * @summary Get Bulk Invoice
 */
export const getBulkInvoice = (bulkInvoiceId: string, signal?: AbortSignal) => {
  return customInstance<BulkInvoiceRead>({
    url: `/api/bulk_invoice/${bulkInvoiceId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkInvoiceQueryKey = (bulkInvoiceId?: string) => {
  return ["api", "bulk_invoice", bulkInvoiceId] as const;
};

export const getGetBulkInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkInvoice>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkInvoiceQueryKey(bulkInvoiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkInvoice>>> = ({
    signal,
  }) => getBulkInvoice(bulkInvoiceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkInvoiceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkInvoice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkInvoice>>
>;
export type GetBulkInvoiceQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkInvoice<
  TData = Awaited<ReturnType<typeof getBulkInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkInvoice>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoice>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoice<
  TData = Awaited<ReturnType<typeof getBulkInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkInvoice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoice>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoice<
  TData = Awaited<ReturnType<typeof getBulkInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Invoice
 */

export function useGetBulkInvoice<
  TData = Awaited<ReturnType<typeof getBulkInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkInvoice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkInvoiceQueryOptions(bulkInvoiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF version of a bulk invoice by ID.
 * @summary Get Bulk Invoice Pdf
 */
export const getBulkInvoicePdf = (
  bulkInvoiceId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_invoice/${bulkInvoiceId}/pdf`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetBulkInvoicePdfQueryKey = (bulkInvoiceId?: string) => {
  return ["api", "bulk_invoice", bulkInvoiceId, "pdf"] as const;
};

export const getGetBulkInvoicePdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkInvoicePdf>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoicePdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkInvoicePdfQueryKey(bulkInvoiceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkInvoicePdf>>
  > = ({ signal }) => getBulkInvoicePdf(bulkInvoiceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkInvoiceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkInvoicePdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkInvoicePdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkInvoicePdf>>
>;
export type GetBulkInvoicePdfQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkInvoicePdf<
  TData = Awaited<ReturnType<typeof getBulkInvoicePdf>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoicePdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoicePdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoicePdf<
  TData = Awaited<ReturnType<typeof getBulkInvoicePdf>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoicePdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof getBulkInvoicePdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkInvoicePdf<
  TData = Awaited<ReturnType<typeof getBulkInvoicePdf>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoicePdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Invoice Pdf
 */

export function useGetBulkInvoicePdf<
  TData = Awaited<ReturnType<typeof getBulkInvoicePdf>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkInvoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkInvoicePdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkInvoicePdfQueryOptions(bulkInvoiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to mark a bulk invoice as paid.

Only users with the administrate_legrande permission can perform this action.
 * @summary Mark Bulk Invoice Paid
 */
export const markBulkInvoicePaid = (
  bulkInvoiceId: string,
  params: MarkBulkInvoicePaidParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_invoice/${bulkInvoiceId}/mark-paid`,
    method: "POST",
    params,
    signal,
  });
};

export const getMarkBulkInvoicePaidMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markBulkInvoicePaid>>,
    TError,
    { bulkInvoiceId: string; params: MarkBulkInvoicePaidParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markBulkInvoicePaid>>,
  TError,
  { bulkInvoiceId: string; params: MarkBulkInvoicePaidParams },
  TContext
> => {
  const mutationKey = ["markBulkInvoicePaid"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markBulkInvoicePaid>>,
    { bulkInvoiceId: string; params: MarkBulkInvoicePaidParams }
  > = (props) => {
    const { bulkInvoiceId, params } = props ?? {};

    return markBulkInvoicePaid(bulkInvoiceId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkBulkInvoicePaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof markBulkInvoicePaid>>
>;

export type MarkBulkInvoicePaidMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Mark Bulk Invoice Paid
 */
export const useMarkBulkInvoicePaid = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markBulkInvoicePaid>>,
      TError,
      { bulkInvoiceId: string; params: MarkBulkInvoicePaidParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markBulkInvoicePaid>>,
  TError,
  { bulkInvoiceId: string; params: MarkBulkInvoicePaidParams },
  TContext
> => {
  const mutationOptions = getMarkBulkInvoicePaidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk invoice's due date.

Only users with the administrate_legrande permission can perform this action.
 * @summary Update Bulk Invoice Due Date
 */
export const updateBulkInvoiceDueDate = (
  bulkInvoiceId: string,
  params: UpdateBulkInvoiceDueDateParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_invoice/${bulkInvoiceId}/due-date`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkInvoiceDueDateMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>,
    TError,
    { bulkInvoiceId: string; params: UpdateBulkInvoiceDueDateParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>,
  TError,
  { bulkInvoiceId: string; params: UpdateBulkInvoiceDueDateParams },
  TContext
> => {
  const mutationKey = ["updateBulkInvoiceDueDate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>,
    { bulkInvoiceId: string; params: UpdateBulkInvoiceDueDateParams }
  > = (props) => {
    const { bulkInvoiceId, params } = props ?? {};

    return updateBulkInvoiceDueDate(bulkInvoiceId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkInvoiceDueDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>
>;

export type UpdateBulkInvoiceDueDateMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Invoice Due Date
 */
export const useUpdateBulkInvoiceDueDate = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>,
      TError,
      { bulkInvoiceId: string; params: UpdateBulkInvoiceDueDateParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkInvoiceDueDate>>,
  TError,
  { bulkInvoiceId: string; params: UpdateBulkInvoiceDueDateParams },
  TContext
> => {
  const mutationOptions = getUpdateBulkInvoiceDueDateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk invoice's payment collector.

Only users with the administrate_legrande permission can perform this action.
 * @summary Update Bulk Invoice Payment Collector
 */
export const updateBulkInvoicePaymentCollector = (
  bulkInvoiceId: string,
  params: UpdateBulkInvoicePaymentCollectorParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_invoice/${bulkInvoiceId}/payment-collector`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkInvoicePaymentCollectorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>,
    TError,
    { bulkInvoiceId: string; params: UpdateBulkInvoicePaymentCollectorParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>,
  TError,
  { bulkInvoiceId: string; params: UpdateBulkInvoicePaymentCollectorParams },
  TContext
> => {
  const mutationKey = ["updateBulkInvoicePaymentCollector"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>,
    { bulkInvoiceId: string; params: UpdateBulkInvoicePaymentCollectorParams }
  > = (props) => {
    const { bulkInvoiceId, params } = props ?? {};

    return updateBulkInvoicePaymentCollector(bulkInvoiceId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkInvoicePaymentCollectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>
>;

export type UpdateBulkInvoicePaymentCollectorMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Invoice Payment Collector
 */
export const useUpdateBulkInvoicePaymentCollector = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>,
      TError,
      {
        bulkInvoiceId: string;
        params: UpdateBulkInvoicePaymentCollectorParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkInvoicePaymentCollector>>,
  TError,
  { bulkInvoiceId: string; params: UpdateBulkInvoicePaymentCollectorParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkInvoicePaymentCollectorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to refund a bulk invoice.

Only users with the administrate_legrande permission can perform this action.
 * @summary Refund Bulk Invoice
 */
export const refundBulkInvoice = (
  bulkInvoiceId: string,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_invoice/${bulkInvoiceId}/refund`,
    method: "POST",
    signal,
  });
};

export const getRefundBulkInvoiceMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refundBulkInvoice>>,
    TError,
    { bulkInvoiceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refundBulkInvoice>>,
  TError,
  { bulkInvoiceId: string },
  TContext
> => {
  const mutationKey = ["refundBulkInvoice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refundBulkInvoice>>,
    { bulkInvoiceId: string }
  > = (props) => {
    const { bulkInvoiceId } = props ?? {};

    return refundBulkInvoice(bulkInvoiceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefundBulkInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof refundBulkInvoice>>
>;

export type RefundBulkInvoiceMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Refund Bulk Invoice
 */
export const useRefundBulkInvoice = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refundBulkInvoice>>,
      TError,
      { bulkInvoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refundBulkInvoice>>,
  TError,
  { bulkInvoiceId: string },
  TContext
> => {
  const mutationOptions = getRefundBulkInvoiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
